/**
 * Formatting a given timestamp into a string representation.
 * @param {number} timestamp - The timestamp to format.
 * @returns {string} The formatted timestamp.
 */
export const timestampToString = (timestamp: number) => {
    if (timestamp < 0) return "Unknown time";

    const date = new Date(timestamp);
    const formatNumber = (n: number): string => n.toString().padStart(2, '0');

    const day = formatNumber(date.getDate());
    const month = formatNumber(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = formatNumber(date.getHours());
    const minutes = formatNumber(date.getMinutes());
    const seconds = formatNumber(date.getSeconds());

    return `${day}.${month}.${year} - ${hours}:${minutes}:${seconds}`;
}